import {
  Component,
  Input,
  TemplateRef, OnChanges
} from '@angular/core';
import {
  BsModalRef,
  BsModalService
} from 'ngx-bootstrap';
import { SocketService } from '../../services';
import { ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { AppService } from 'app/services/app.service';
import { LocalStorageHelpers } from 'app/helpers';

@Component({
  selector: 'app-message-modal',
  templateUrl: './app-message-modal.component.html',
  styleUrls: ['./app-message-modal.component.scss']
})
export class AppMessageModalComponent implements OnChanges {

  @Input() receivers = [];
  @Input() context: string;
  @Input() context_id: number;
  modalRef: BsModalRef;
  template: TemplateRef<any>;
  private sending = false;
  private message = '';

  constructor(
    private modalService: BsModalService,
    // private socketService: SocketService,
    private route: ActivatedRoute,
    private toasterService: ToasterService,
    private appService: AppService,
    private localStorageHelpers: LocalStorageHelpers
  ) {
    this.route.params.subscribe(params => {
      // console.log('params', params);
    });
  }

  ngOnChanges() { }

  send() {
    if (this.receivers) {
      const receivers_ids = [];
      for (const i in this.receivers) {
        if (this.receivers) {
          receivers_ids.push(this.receivers[i]['users_id'] ?
            this.receivers[i]['users_id'] :
            this.receivers[i]['id']);
        }
      }
      // const sendSub = this.socketService.sendMultiple(receivers_ids, this.message, this.context, this.context_id);
      const sendSub = this.appService.putSendMessage({
        users_id: receivers_ids,
        employer_id: JSON.parse(this.localStorageHelpers.get('userData')).id,
        message: this.message});
      sendSub.subscribe(() => {
        this.toasterService.pop('success', 'Success', 'Messages sent');
      }, err => {
        this.toasterService.pop('error', 'Error', err);
      });

      this.message = '';
      this.modalRef.hide();
    }
  }

  openModal(template: TemplateRef<any>) {
    this.template = template;
    this.modalRef = this.modalService.show(template);
  }



}
